<template>
    <div class="pinfomacchina">
        <b-tabs content-class="mt-3" @input="tabChanged">
            <b-tab :title="machine.codice" active>
                <PIIssues :m="machine" height="calc(100vh - 320px)" :key="calKey" />
            </b-tab>
            <b-tab title="Threads + Docs">
                <PIThreads :m="machine" height="calc(100vh - 320px)" :key="calKey" />
            </b-tab>
            <b-tab title="Machine Calendar">
                <PICalendar :key="calKey" />
            </b-tab>
            <b-tab title="Team">
                <PITeam  :key="calKey" />
            </b-tab>
            <!-- <b-tab title="Documents">
                <PIDocuments  :key="calKey" />
            </b-tab> -->
        </b-tabs>
    </div>
</template>
<script>
// import { API } from "@/api.js";
import PIIssues from "@/views/prodinst/PIIssues.vue";
import PICalendar from "@/views/prodinst/PICalendar.vue";
// import PIDocuments from "@/views/prodinst/PIDocuments.vue";
import PIThreads from "@/views/prodinst/PIThreads.vue";
import PITeam from "@/views/prodinst/PITeam.vue";

export default {
    name: "PInfoMacchina",
    data() {
        return {
			currTab: -1,
            calKey: 0, // per forzare un render al cambio di tab
        };
    },
    components: {
        PIIssues,
        PICalendar,
        // PIDocuments,
        PIThreads,
        PITeam,
    },
    computed: {
        machine() {
            return this.$store.getters.machine;
        },
        section(){
            return this.$store.getters.section
        },
    },
    async mounted() {
        this.$store.commit("issue", null);
    },
    methods: {
        tabChanged(index) {
            this.$store.commit("issue", null);
            this.currTab = index;
            this.calKey++;
        },
    },
};
</script>
<style scoped>
div.pinfomacchina {
    background-color: #d3d3d3;
    overflow: auto;
    height: 87vh;
    max-height: 87vh;
}
div.pinfomacchina div.card {
    margin: 0px;
}
</style>
